import { Component, OnInit, Inject, ChangeDetectorRef} from '@angular/core';
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { MAT_DIALOG_DATA , MatDialog, MatDialogRef} from '@angular/material';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare var google: any;
declare let L;

@Component({
  selector: 'app-define-area-modal',
  templateUrl: './define-area-modal.component.html',
  styleUrls: ['./define-area-modal.component.css']
})
export class DefineAreaModalComponent implements OnInit {

  surveyName:string;
  teamName:string;
  locations : any[];
  latitudes : any;
  longitudes : any;
  newloc: boolean;
  map :any;
  arrCircle:any = [];
  markerOnMap:any;
  popupIcon = L.icon({
    iconUrl: 'assets/images/marker-unselected.svg',
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private dialogRef : MatDialogRef<DefineAreaModalComponent>, private restApiService:RestApiService,private toastyService:ToastyService,private cdr:ChangeDetectorRef) { }

  ngOnInit() {
    if(this.data && this.data.surveyName){
      this.surveyName = this.data.surveyName;
    }
    if(this.data && this.data.teamName){
      this.teamName = this.data.teamName;
    }
    if(this.data.teamID == '0'){
      this.locations = [{'name':'','radius':0,'limit':10,'responses':'0','status': 1, 'edit' : 1}];
      this.newloc = false;
      this.latitudes = [];
      this.longitudes = [];
      this.arrCircle = [];
      this.map = L.map('map').setView([25, 80], 4.5);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
    }
    else{
      this.onmapview();
    }
  }

  onSave(index){
    for(let location in this.locations){
      // if(this.locations[location]['status'] == 1){
      //   this.locations.splice(parseInt(location),1)
      // }
      // else{
        this.locations[location]['status'] = null;
        delete this.locations[location]['status'];
        delete this.locations[location]['edit'];
      }
    // }
    if(this.data.teamID != '0'){
      if (this.locations[index].name != '' && this.locations[index].radius != 0 && this.locations[index].limit != 0) {
        this.restApiService.setlocations(this.data.qID, this.locations, this.latitudes, this.longitudes, this.data.teamID).subscribe(
          result => {
            if (result.success == true) {
              this.locations[index].status = 0;
              this.locations[index].edit = 0;
              this.newloc = true;
  
              var toastOptions: ToastOptions = {
                title: "Location Added",
                msg: "Location -  " + this.locations[index]['name'] + ' was successfully added.',
                showClose: true,
                timeout: 3000,
                theme: 'bootstrap'
              };
              this.toastyService.success(toastOptions);
            }
          });
      }
    }
  }

  addlocation(){
    this.locations.push({'name':'','radius':0,'limit':10,'responses':'0','status': 1, 'edit' : 1});
  }

  onDelete(index){
    this.locations.splice(index,1);
    this.latitudes.splice(index,1);
    this.longitudes.splice(index,1);
    if(this.data.teamID != '0'){
      this.restApiService.deletelocations(this.data.qID,this.data.teamID,index).subscribe(result=>{
        if(result && result.success == true){
          var toastOptions:ToastOptions = {
            title: "Location Removed",
            msg: "Location - "+  this.locations[index]['name']  + ' was successfully removed.',
            showClose: true,
            timeout: 3000,
            theme: 'bootstrap'
          };
          this.toastyService.success(toastOptions);
          this.map.remove();
          this.onmapview();
        }
      })
    }
  }

  invalidDefineArea(){
    for (let index = 0; index < this.locations.length; index++) {
      if(this.locations[index].status == 1 || this.locations[index].edit == 1){
        return true;
      }
    }
    return false;
  }

  saveDefinedArea(){
    if(this.data.teamID != '0'){
      this.onBack();
    }
    else{
      for (let index = 0; index < this.locations.length; index++) {
        if(this.locations[index].status == 1 || this.locations[index].edit == 1){
          return;
        }
      }
      const definedArea = {
        surveyData: true,
        locations: this.locations,
        lat: this.latitudes,
        lng: this.longitudes
      }
      this.dialogRef.close(definedArea);
    }
  }

  onBack(){
    let count = 0;
    this.locations.forEach(data=>{
      if(data.name != ''){
        count = count +1;
      }
    })
    if(count == 0){
      this.dialogRef.close({success : false, count :null});
    }
    else{
      this.dialogRef.close({success : false, count :count});
    }
  }

  onKeyLimit(event:any , index){
    this.locations[index].status = 1;
  }

  onKeyname(event: any, index) {
    let address = event.target.value;

    let obj = document.getElementById('address'+index);
    let autocomplete = new google.maps.places.Autocomplete(obj, { types: ['geocode'] });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        let place = autocomplete.getPlace(), has_name = (place && undefined !== place.name), count = 0;
        let keys = Object.keys(place);
        count = keys.length;
        if (has_name && count < 2) {
          this.locations[index].name = address;
          this.restApiService.getLatLong(address).subscribe(
            result => {
              this.getAddressCoordinates(result,index);
            });
        } else {
            this.locations[index].name = place.formatted_address;
            let latitude = place.geometry.location.lat();
            let longitude = place.geometry.location.lng();
            this.getAddressCoordinates({result:{lat: latitude, lng: longitude}},index);
        }
    });

  }


  editLocationDetails(index){
    this.locations[index].edit = 1;
    this.locations[index].status = 0;
  }

  getAddressCoordinates(result,index){
      this.locations[index].status = 1;
        this.latitudes[index] = parseFloat(result.result.lat);
        this.longitudes[index] = parseFloat(result.result.lng);
        if(this.markerOnMap){
          this.markerOnMap.remove();
        }
        this.markerOnMap = L.marker([ this.latitudes[index],this.longitudes[index]], {draggable: true}).setIcon(this.popupIcon) .addTo(this.map);
        this.markerOnMap.on('dragend', (event)=>{
          var marker = event.target;
          var position = marker.getLatLng();
          this.locations[index].name = "{" + position.lat +" " +  position.lng + "}";
          this.cdr.detectChanges();
          this.arrCircle[index].remove();
          if (this.locations[index].radius == 0) {
            this.arrCircle[index] = L.circle([parseFloat(position.lat), parseFloat(position.lng)]).addTo(this.map);
          }
          else {
            this.arrCircle[index] = L.circle([parseFloat(position.lat), parseFloat(position.lng)],  { radius :  parseInt(this.locations[index].radius)}).addTo(this.map);
          }
          marker.setLatLng(new L.LatLng(position.lat, position.lng),{draggable:true});
        });
        this.map.setView([parseFloat(this.latitudes[index]),parseFloat(this.longitudes[index])],4.5)
        for (let i = 0; i < this.latitudes.length; i++) {
          if (this.arrCircle.length > index) {
            this.arrCircle[index].remove();
            if (this.locations[index].radius == 0) {
              this.arrCircle[index] = L.circle([parseFloat(this.latitudes[i]), parseFloat(this.longitudes[i])]).addTo(this.map);
            }
            else {
              this.arrCircle[index] = L.circle([parseFloat(this.latitudes[i]), parseFloat(this.longitudes[i])],  { radius :  parseInt(this.locations[i].radius)}).addTo(this.map);
            }
          }
          else {
            if (this.locations[index].radius == 0) {
              this.arrCircle.push(L.circle([parseFloat(this.latitudes[i]), parseFloat(this.longitudes[i])]).addTo(this.map));
            }
            else {
              this.arrCircle.push(L.circle([parseFloat(this.latitudes[i]), parseFloat(this.longitudes[i])],  { radius :  parseInt(this.locations[i].radius) }).addTo(this.map));
            }
          }
        }
  }

  onmapview(){
    this.restApiService.getlocations(this.data.qID,this.data.teamID).subscribe(
      result => {
        if(result.result.length == 0 || result.result[0].area_details == 0){
          this.locations = [{'name':'','radius':0,'limit':10,'responses':'0','status': 1, 'edit' : 1}];
          this.newloc = false;
          this.latitudes = [];
          this.longitudes = [];
          this.arrCircle = [];
          this.map = L.map('map').setView([25, 80], 4.5);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
        }
        else{
          this.locations = result.result[0].area_details;
          this.latitudes = result.result[0].latitudes;
          this.longitudes = result.result[0].longitudes;
          this.arrCircle = [];
          this.newloc = true;
          this.map = L.map('map').setView([parseFloat(this.latitudes[0]),parseFloat(this.longitudes[0])], 6);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
          for(let i = 0; i < this.latitudes.length; i++){
            this.arrCircle.push(L.circle([parseFloat(this.latitudes[i]),parseFloat(this.longitudes[i])], {radius : parseInt(this.locations[i].radius)  } ).addTo(this.map))
          }
        }
      });
  }

  onKeyRadius(event:any,index){
    if(this.markerOnMap){
      this.markerOnMap.remove();
    }
    if(this.locations[index].radius != '' && this.locations[index].name !=''){
      this.locations[index].status = 1;
        if(this.arrCircle.length > index)
        {
          this.arrCircle[index].remove();
          this.arrCircle[index] = L.circle([parseFloat(this.latitudes[index]),parseFloat(this.longitudes[index])], { radius :  parseInt(this.locations[index].radius) }).addTo(this.map);
        }
        else{
          this.arrCircle.push(L.circle([parseFloat(this.latitudes[index]),parseFloat(this.longitudes[index])], { radius :  parseInt(this.locations[index].radius)  }).addTo(this.map));
        }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/define-area-modal/define-area-modal.component.ts